
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlSlug]/details",
      function () {
        return require("private-next-pages/[urlSlug]/details/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[urlSlug]/details"])
      });
    }
  